<template>
    <div>
      <tender-details v-if="tender" :tender="tender"></tender-details>
      <loading v-if="loading"></loading>
    </div>
</template>

<script>
  import TenderDetails from './Details'

  export default {
    components: {
      TenderDetails
    },

    computed: {
      tenderId() {
        return +this.$route.params.tenderId;
      },

      tender() {
        return this.$store.getters.tender(this.tenderId);
      }
    },

    async created() {
      this.runAction(async () => {
        try {
          await this.$store.dispatch('fetchTender', { tenderId: this.tenderId });
        }
        catch(e) {
          console.error('unable to fetch tender', e);
          this.globalErrorHandler(e);
        }
      });
    }
  }
</script>

<style scoped>

</style>
